import { render, staticRenderFns } from "./menu.component.vue?vue&type=template&id=912a8350&scoped=true&"
import script from "./menu.component.vue?vue&type=script&lang=js&"
export * from "./menu.component.vue?vue&type=script&lang=js&"
import style0 from "./menu.component.vue?vue&type=style&index=0&id=912a8350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912a8350",
  null
  
)

export default component.exports